import stringsES from "./stringsES";
import stringsEN from "./stringsEN";
import esLocale from "date-fns/locale/es";
import enLocale from "date-fns/locale/en-US";
import {
  setOptions as setMobiscrollOptions,
  localeEs,
  localeEn,
} from '@mobiscroll/react';
import { setKeyValue as setLocalStorageValue } from "@icarius-utils/localStorage";

const DEFAULT_LANGUAGE = "es";

const translations = {
  es: stringsES,
  en: stringsEN,
};

const dateLocales = {
  es: esLocale,
  en: enLocale,
};

export let language;
export let dateLocale;
export const LOCAL_STORAGE_LANGUAGE_KEY = "icarius-language";

export const setLanguage = (newLanguage, callback) => {
  const languageToSet = newLanguage || DEFAULT_LANGUAGE;

  language = languageToSet;
  dateLocale = dateLocales[languageToSet];

  setMobiscrollOptions({
    locale: language === "es" ? localeEs : localeEn,
  });

  setLocalStorageValue(LOCAL_STORAGE_LANGUAGE_KEY, languageToSet);
  if (callback) callback();
}

const replaceMarkedStrings = (text, replacements = {}) => {
  if (!Object.keys(replacements).length) return text;

  return text.replace(/\{([^{}]+)\}/g, (match, key) => {
    return key in replacements ? replacements[key] : match;
  });
}

export const getLocalizedString = (stringKey, replacements) => {
  let text = translations[language || DEFAULT_LANGUAGE][stringKey] || stringKey; // si no encuentra el string, devuelve la key para ver donde falta
  return replaceMarkedStrings(text, replacements);
}

export const getErrorStringFromServerError = (error) => {
  const SERVER_ERRORS = {
    DEFAULT_EXCEPTION: getLocalizedString("defaultException"),
    INVALID_TOKEN_PROVIDED: getLocalizedString("invalidToken"),
    NO_TOKEN_PROVIDED: getLocalizedString("tokenMissing"),
    INVALID_PARAMETERS: getLocalizedString("invalidParams"),
    USER_NOT_REGISTERED: getLocalizedString("userNotFound"),
    PinValidationError: getLocalizedString("pinValidationError"),
    INVALID_PARAMS: getLocalizedString("invalidParams"),
    USER_NOT_FOUND: getLocalizedString("userNotFound"),
    SERVER_ERROR: getLocalizedString("serverError"),
    SOCIETY_NOT_FOUND: getLocalizedString("societyNotFound"),
    INVALID_CREDENTIALS: getLocalizedString("loginInvalidCredentials"),
    USER_ALREADY_EXISTS: getLocalizedString("userAlreadyExists"),
    GOOGLE_DATA_ERROR: getLocalizedString("googleDataError"),
    UNAUTHORIZED: getLocalizedString("unAuthorized"),
    NO_EMPLOYEES: getLocalizedString("emptyEmployees"),
    INVALID_IMAGES: getLocalizedString("invalidImages"),
    INVALID_DATA: getLocalizedString("invalidDataAlt"),
    ClientNotExist: getLocalizedString("clientNotExist"),
    VALIDATION_ERROR: getLocalizedString("validationErrorAlt"),
    TOTEM_EXISTS: getLocalizedString("totemAlreadyExists"),
  };

  try {
    if (error.msg) return error.msg;
    return SERVER_ERRORS[error.response.data.status] ? SERVER_ERRORS[error.response.data.status] : getLocalizedString("defaultException");
  } catch (e) {
    return getLocalizedString("defaultException");
  }
};